(function () {
  'use strict';

  // Only run on devices with a real mouse pointer — never touch/tablet.
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cursor = document.createElement('div');
  cursor.setAttribute('aria-hidden', 'true');
  cursor.style.cssText = [
    'position:fixed',
    'top:0',
    'left:0',
    'width:22px',
    'height:22px',
    'pointer-events:none',
    'z-index:9999',
    'transform:translate(-50%,-50%)',
    'transition:transform .18s ease-out',
    'will-change:transform'
  ].join(';');

  cursor.innerHTML =
    '<svg viewBox="0 0 26 24" width="22" height="22" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M13 22 C 4 15, -2 6, 6 2 C 10 0, 13 3, 13 6 C 13 3, 16 0, 20 2 C 28 6, 22 15, 13 22 Z" ' +
    'fill="none" stroke="#C4A882" stroke-width="1.6" class="vina-cursor-heart"/></svg>';

  document.documentElement.appendChild(cursor);
  document.documentElement.style.cursor = 'none';

  var heartPath = cursor.querySelector('.vina-cursor-heart');

  var mouseX = window.innerWidth / 2;
  var mouseY = window.innerHeight / 2;
  var curX = mouseX;
  var curY = mouseY;

  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function tick() {
    // Gentle lag/ease toward the real pointer position for a soft trailing feel.
    var ease = reduceMotion ? 1 : 0.18;
    curX += (mouseX - curX) * ease;
    curY += (mouseY - curY) * ease;
    cursor.style.left = curX + 'px';
    cursor.style.top = curY + 'px';
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  // Fill + scale up on anything clickable.
  var clickableSelector = 'a, button, [role="button"], input, textarea, select, .vina-card, summary, label';

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(clickableSelector)) {
      cursor.style.transform = 'translate(-50%,-50%) scale(1.3)';
      heartPath.setAttribute('fill', '#C4A882');
      heartPath.setAttribute('stroke', '#C4A882');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(clickableSelector)) {
      cursor.style.transform = 'translate(-50%,-50%) scale(1)';
      heartPath.setAttribute('fill', 'none');
      heartPath.setAttribute('stroke', '#C4A882');
    }
  });

  // Never let the cursor linger if the pointer leaves the window.
  document.addEventListener('mouseleave', function () {
    cursor.style.opacity = '0';
  });
  document.addEventListener('mouseenter', function () {
    cursor.style.opacity = '1';
  });
})();
